export const machines = [
  { id: 'aerocycle', name: 'Aérocycle' },
  { id: 'albatros', name: 'Albatros' },
  { id: 'anax', name: 'Anax' },
  { id: 'autographometre', name: 'Autographomètre' },
  { id: 'batfly', name: 'Batfly' },
  { id: 'bernina', name: 'Bernin/A' },
  { id: 'bicycle', name: 'Bicycle' },
  { id: 'bombyx', name: 'Bombyx' },
  { id: 'cephaloscope', name: 'Céphaloscope' },
  { id: 'chrono', name: 'Chronos 2' },
  { id: 'chronos', name: 'Chronos' },
  { id: 'faucon', name: 'Faucon' },
  { id: 'frelon', name: 'Frelon' },
  { id: 'furax', name: 'Furax' },
  { id: 'gargantua', name: 'Gargantua' },
  { id: 'gerris', name: 'Gerris' },
  { id: 'gyroptere', name: 'Gyroptère' },
  { id: 'hercule', name: 'Hercule' },
  { id: 'icarius', name: 'Icarius' },
  { id: 'klg', name: 'KLG' },
  { id: 'lucane', name: 'Lucane' },
  { id: 'luciole', name: 'Luciole' },
  { id: 'luxor', name: 'Luxor' },
  { id: 'marchant', name: 'Marchant' },
  { id: 'mystral', name: 'Mystral' },
  { id: 'nautile', name: 'Nautile' },
  { id: 'octodus', name: 'Octodus' },
  { id: 'planet', name: 'Planet' },
  { id: 'polaris', name: 'Polaris' },
  { id: 'rocket', name: 'Rocket' },
  { id: 'stellar', name: 'Stellar' },
  { id: 'suricate', name: 'Suricate' },
  { id: 'tamanoir', name: 'Tamanoir' },
  { id: 'tornado', name: 'Tornado' },
  { id: 'torpeur', name: 'Torpeur' },
  { id: 'truffier', name: 'Truffier' },
  { id: 'underwood', name: 'Underwood' },
  { id: 'vigilant', name: 'Vigilant' },
  { id: 'vulcan', name: 'Vulcan-X3' }
];